module.exports = __webpack_public_path__ + "img/logo-pb.f995d514.png";